import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import promise from "redux-promise-middleware";
import thunk from "redux-thunk";
import { blogsReducers } from "./blogs/index";
import { dashReducers } from "./dashboard";
import { jobReducers } from "./jobs";
import { newsletterReducers } from "./newsletter";
import { reportReducers } from "./reports";
import { uploadReducers } from "./upload";
import { usersReducers } from "./users";
import { galleryReducers } from "./gallery";
import { videoGalleryReducers } from "./gallery/videos";
import { partnerReducers } from "./partners";
import { generalReducers } from "./general";
import { metricsReducers } from "./metrics";
import {contactsReducers} from "./contacts";
import { SubscriberReducers } from "./subscriptions";
import { productsReducers } from "./products/index";
import { faqsReducers } from "./faqs";

const reducers = combineReducers({
  ...blogsReducers,
  ...uploadReducers,
  ...newsletterReducers,
  ...jobReducers,
  ...dashReducers,
  ...reportReducers,
  ...usersReducers,
  ...usersReducers,
  ...galleryReducers,
  ...videoGalleryReducers,
  ...partnerReducers,
  ...generalReducers,
  ...metricsReducers,
  ...contactsReducers,
  ...SubscriberReducers,
  ...productsReducers,
  ...faqsReducers
});

export default () => {
  const store = createStore(
    reducers,
    {},
    composeWithDevTools(applyMiddleware(thunk, promise))
  );

  return store;
};
